import './login.css'

import { useState } from 'react'
import { Row, Col, Form, Input, Button, Spin, Modal } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { baseAxiosComplete } from '../../tool/axios'
import { apiPrefix } from '../../js/config'
import iconLogo from '../../images/icon.png'
import Cookie from 'js-cookie'

export default function Login() {

    const [form] = useForm()
    const [count, setCount] = useState<number>(60)
    const [decreasing, setDecreasing] = useState<boolean>(false)

    const [loading, setLoading] = useState<boolean>(false)

    const getPhoneCode = () => {
        if (form.getFieldValue('user_name') && form.getFieldValue('phone')) {
            baseAxiosComplete.get('/global/get_verify_code', {
                params: {
                    user_name: form.getFieldValue('user_name'),
                    phone: form.getFieldValue('phone')
                }

            }).then(res => {
                if (res.status === 0 && !decreasing) {
                    setDecreasing(true)

                    let num = count
                    let timer = setInterval(() => {
                        if (num <= 0) {
                            clearInterval(timer)
                            setCount(60)
                            setDecreasing(false)

                        } else {
                            num--
                            setCount(num)
                        }
                    }, 1000)
                }
            })
        }
    }

    function onFinish(values: any) {
        setLoading(true)

        baseAxiosComplete.post(apiPrefix + '/global/login', {
            user_name: form.getFieldValue('user_name'),
            phone: form.getFieldValue('phone'),
            verify_code: form.getFieldValue('code')

        }).then((res: any) => {
            setLoading(false)

            if (res.status === 0) {
                Cookie.set('token', res.data.token, { expires: new Date('3022-12-12') }) // 后端限7天
                localStorage.setItem('userData', JSON.stringify(res.data))
                window.location.pathname = ''
            }
        })
    }

    return <div id="login">
        {/* 登录页面 */}
        <Row id="login-row" justify="center">
            <Col id="login-col" xxl={5} xl={6} md={6} sm={10} >
                <h1 style={{ color: '#4B4D5B', width: 280 }}><img src={iconLogo} style={{ width: 30, marginTop: -2, marginRight: 10 }} />兴宝月禧业务中台</h1>

                <Form id="login-form" name="normal_login" className="login-form" form={form} onFinish={onFinish} size="large" >
                    <Form.Item name="user_name" rules={[{ required: true, message: '姓名' }]}>
                        <Input placeholder="用户名" />
                    </Form.Item>

                    <Form.Item name="phone" rules={[{ required: true, message: '手机号' }]}>
                        <Input placeholder="手机号" />
                    </Form.Item>

                    <Form.Item name="code" rules={[{ required: true, message: '短信验证码' }, { max: 6, message: '六位数验证码' }, { min: 6, message: '六位数验证码' }]}>
                        <Form.Item style={{ height: '18px' }} >
                            <Input placeholder="短信验证码" />
                            {!decreasing ? <div id="get-code" onClick={getPhoneCode}>获取验证码</div> : <div id="reset-seconds">已发送，剩余{count}秒</div>}
                        </Form.Item>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button" >登录</Button>
                    </Form.Item>
                </Form>
            </Col>
        </Row>

        <Modal visible={loading} footer={false} closable={false} style={{ textAlign: 'center' }}  >
            <Spin />
        </Modal>
    </div>
}